module.exports = __webpack_public_path__ + "img/aditya birla.3bc534fd.png";